var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout-sidebar-section" },
    [
      _c(
        "div",
        {
          staticClass: "layout-sidebar-section-title",
          on: {
            click: function ($event) {
              return _vm.$emit("toggleSection", "transformSection")
            },
          },
        },
        [
          _c("strong", [_vm._v("Transform")]),
          _vm._v(" "),
          _c("b-icon", {
            attrs: {
              icon: _vm.isOpen.transformSection ? "chevron-up" : "chevron-down",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        [
          _c(
            "b-collapse",
            { attrs: { visible: _vm.isOpen.transformSection } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: true,
                      expression: "true",
                    },
                  ],
                },
                [
                  _c(
                    "b-form-row",
                    [
                      _vm.aspectRatioOption && _vm.showKeepAspectRatio
                        ? _c(
                            "b-col",
                            {
                              staticClass:
                                "mb-2 d-flex justify-content-between align-items-center",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "b-checkbox",
                                {
                                  attrs: { disabled: _vm.target.locked },
                                  model: {
                                    value: _vm.keepAspectRatioValue,
                                    callback: function ($$v) {
                                      _vm.keepAspectRatioValue = $$v
                                    },
                                    expression: "keepAspectRatioValue",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Keep aspect ratio\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  attrs: {
                                    id: "align-to-ruler-dropdown",
                                    variant: "link",
                                    "toggle-class": "align-to-ruler-toggle",
                                    "no-caret": "",
                                    right: "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button-content",
                                        fn: function () {
                                          return [
                                            _c("img", {
                                              attrs: {
                                                src: "/img/icons/measure.png",
                                                width: "24",
                                                height: "24",
                                                alt: "Align Options",
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    2817049671
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.alignToRulerLine(
                                            _vm.RULER_ALIGN.LEFT
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Align to left ruler line\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.alignToRulerLine(
                                            _vm.RULER_ALIGN.RIGHT
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Align to right ruler line\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.alignToRulerLine(
                                            _vm.RULER_ALIGN.TOP
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Align to upper ruler line\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.alignToRulerLine(
                                            _vm.RULER_ALIGN.BOTTOM
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Align to lower ruler line\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "X",
                                "label-cols": "2",
                                disabled: _vm.target.locked || !_vm.moveable,
                              },
                            },
                            [
                              _c("b-input", {
                                attrs: {
                                  value: _vm.xValue.toFixed(2),
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onInput("x", $event)
                                  },
                                  dblclick: _vm.selectValueOnDblclick,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Y",
                                "label-cols": "2",
                                disabled: _vm.target.locked || !_vm.moveable,
                              },
                            },
                            [
                              _c("b-input", {
                                attrs: {
                                  value: _vm.yValue.toFixed(2),
                                  type: "number",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onInput("y", $event)
                                  },
                                  dblclick: _vm.selectValueOnDblclick,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showSize
                        ? _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "W",
                                    "label-cols": "2",
                                    disabled:
                                      _vm.target.locked || _vm.isScaleDisabled,
                                  },
                                },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      value: _vm.wValue.toFixed(2),
                                      type: "number",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onInput("w", $event)
                                      },
                                      dblclick: _vm.selectValueOnDblclick,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSize
                        ? _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "H",
                                    "label-cols": "2",
                                    disabled:
                                      _vm.target.locked || _vm.isScaleDisabled,
                                  },
                                },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      value: _vm.hValue.toFixed(2),
                                      type: "number",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onInput("h", $event)
                                      },
                                      dblclick: _vm.selectValueOnDblclick,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }